<div class="v3-members">
  <h1 hidden="true" *ngIf="!isInDialogMode">
    {{ 'translations.adminUsersPageLabel' | transloco }}
  </h1>

  <ptl-skeleton-view *ngIf="skeletonViewActive" [state]="{ loading: true }" [countInput]="13" [viewType]="'table'"></ptl-skeleton-view>

  <div [class.is_hidden]="skeletonViewActive">
    <div class="v3-members__error" *ngIf="showNotPermittedMessage">
      {{ 'translations.members.label.noPermittedToViewMembers' | transloco: { organization: (organizationData$ | async)?.name } }}
    </div>

    <div
      class="v3-members__outer"
      (keydown.enter)="onCloseDialog($event)"
      (click)="onCloseDialog($event)"
      [class.dialog-mode]="isInDialogMode"
      [class.page-has-offset]="isCardPage || isPlaylistPage || isEvent"
    >
      <div
        class="v3-members__container"
        [class.dialog-mode]="isInDialogMode"
        [class.small-container]="isCardPage || isPlaylistPage || isEvent"
        *ngIf="!showNotPermittedMessage"
      >
        <ptl-alert
          *ngIf="showAlert"
          [type]="alertType"
          [message]="alertMessage"
          [textClickable]="alertTextClickable"
          (actionClicked)="onActionClicked()"
          (closeClicked)="hideAlertMessage()"
        ></ptl-alert>

        <div
          class="v3-members__table-section"
          id="adminMemberTableContainer"
          [class.reduced-top-spacing]="!isCardPage && !isPlaylistPage"
          [class.dialog-mode]="isInDialogMode"
        >
          <ng-container *ngIf="isPlaylistPage">
            <ptl-v3-target-audience-section [style.display]="isInDialogMode ? 'none' : 'block'"></ptl-v3-target-audience-section>
          </ng-container>

          <div class="v3-members__control-panel" [class.dialog-mode]="isInDialogMode">
            <div class="v3-members__close-btn" *ngIf="isInDialogMode">
              <button
                class="v3-members__close-dialog-btn"
                mat-icon-button
                color="primary"
                (click)="disableDialogMode()"
                [attr.aria-label]="'translations.global.ariaLabels.closeDialog' | transloco"
              >
                <svg class="svg" role="img" aria-hidden="true">
                  <use ogSvgUnify="assets/sprite/sprite.svg#close"></use>
                </svg>
              </button>
            </div>

            <ptl-v3-admin-member-control-panel
              #controlPanel
              [columns]="columns"
              [isAdminPage]="!isCardPage && !isPlaylistPage"
              [isPlaylistPage]="isPlaylistPage"
              [isCardPage]="isCardPage"
              [isWaitingListOperationDisabled]="isWaitingListOperationDisabled"
              [isAssessment]="isAssessment"
              [isEvent]="isEvent"
              [totalMembersCount]="membersTotalCount"
              [allMembersCount]="membersAllCount"
              [booleanSearchRequest]="{ query: queryRequest }"
              [playlistUid]="playlistUid"
              [cardUid]="cardUid"
              [courseUid]="courseUid"
              [exportEnabled]="exportEnabled || (!isCardPage && !isPlaylistPage)"
              [exportName]="resourceUri"
              [isWaitingListEnabled]="isWaitingListEnabled"
              [cardHeaders]="cardHeaders"
              [formHeaders]="formHeaders"
              [eventFinished]="eventFinished"
              (reviewersChanged)="onReviewersUpdate()"
              (refreshList)="refreshList($event)"
              (triggerUserImport)="onTriggerUserImport($event)"
              (filterChanged)="onFilterChanged($event)"
              (csvFileUploadFinished)="refreshTableWithDelay($event, true)"
            >
              <ptl-v3-admin-action-buttons
                toolbar-actions
                *ngIf="members?.length"
                class="v3-members__action-buttons"
                [columns]="columns"
                [isAdminPage]="!isCardPage && !isPlaylistPage"
                [isPlaylistPage]="isPlaylistPage"
                [isCardPage]="isCardPage"
                [isWaitingListOperationDisabled]="isWaitingListOperationDisabled"
                [isAssessment]="isAssessment"
                [isEvent]="isEvent"
                [checkedMembers]="checkedMembers"
                [totalMembersCount]="membersTotalCount"
                [allMembersCount]="membersAllCount"
                [booleanSearchRequest]="{ query: queryRequest }"
                [playlistUid]="playlistUid"
                [cardUid]="cardUid"
                [courseUid]="courseUid"
                [exportEnabled]="exportEnabled || (!isCardPage && !isPlaylistPage)"
                [exportName]="resourceUri"
                [isWaitingListEnabled]="isWaitingListEnabled"
                [eventFinished]="eventFinished"
                (reviewersChanged)="onReviewersUpdate()"
                (memberActionTriggered)="handleMemberAction($event)"
                (refreshList)="refreshList($event)"
                (triggerUserImport)="onTriggerUserImport($event)"
                (csvFileUploadFinished)="refreshTableWithDelay($event, true)"
              ></ptl-v3-admin-action-buttons>
            </ptl-v3-admin-member-control-panel>
          </div>

          <ptl-v3-admin-member-list
            class="v3-members__list f_admin-member-list-container"
            #membersList
            *ngIf="membersListLoaded"
            [columns]="columns"
            [currentPage]="page"
            [booleanSearchRequest]="{ query: queryRequest }"
            [pageSize]="pageSize"
            [isPlaylistPage]="isPlaylistPage"
            [playlistUid]="playlistUid"
            [cardUid]="cardUid"
            [isCardPage]="isCardPage"
            [isEvent]="isEvent"
            [members]="members"
            [membersTotalCount]="membersTotalCount"
            [isWaitingListEnabled]="isWaitingListEnabled"
            [isWaitingListOperationDisabled]="isWaitingListOperationDisabled"
            [orderInput]="order"
            [paginationLength]="paginationLength"
            [filtered]="controlPanel.hasSearchOrFilters"
            (orderChanged)="changeListOrderingByBooleanFilter($event)"
            (clearFilters)="controlPanel.clearSearchAndFilters()"
            (membersChecked)="onMembersChecked($event)"
            (memberActionTriggered)="handleMemberAction($event)"
            (refreshList)="refreshList($event)"
          ></ptl-v3-admin-member-list>
        </div>
      </div>
    </div>
  </div>
</div>
